import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_CAMPAIGN_FILTERS, FilterStateCampaigns } from "./types";

const initialState: FilterStateCampaigns = {
  filters: DEFAULT_CAMPAIGN_FILTERS,
};

const campaignFilterSlice = createSlice({
  name: "campaignFilter",
  initialState,
  reducers: {
    updateFilter(
      state,
      action: PayloadAction<{ key: string; value: unknown }>
    ) {
      const { key, value } = action.payload;

      if (key === "meta") {
        state.filters.meta = { ...state.filters.meta, ...(value as object) };
      } else {
        (state.filters as Record<string, unknown>)[key] = value;
      }

      if (key !== "meta") {
        state.filters.meta = { ...state.filters.meta, page: 1 };
      }
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { updateFilter, resetFilters } = campaignFilterSlice.actions;
export default campaignFilterSlice.reducer;
